import { render, staticRenderFns } from "./dashVoucher.vue?vue&type=template&id=c85d1220&scoped=true"
import script from "./dashVoucher.vue?vue&type=script&lang=js"
export * from "./dashVoucher.vue?vue&type=script&lang=js"
import style0 from "./dashVoucher.vue?vue&type=style&index=0&id=c85d1220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85d1220",
  null
  
)

export default component.exports